<template>
  <div class="skeleton-activity-stream">
    <fts-skeleton size="50px" avatar class="skel-activity-stream-avatar" />
    <div class="skel-activity-stream-info">
      <!-- alpha -->
      <div class="skel-activity-stream-row-alpha">
        <fts-skeleton height="18px" width="70%" />
      </div>
      <!-- beta -->
      <div class="skel-activity-stream-row-beta">
        <div class="skel-activity-stream-row-beta-l">
          <fts-skeleton height="14px" width="60%" />
        </div>
        <div class="skel-audit">
          <fts-skeleton size="20px" avatar class="skel-audit-profile" />
          <fts-skeleton height="14px" width="42px" />
        </div>
      </div>
      <!-- gamma -->
      <div class="skel-activity-stream-row-gamma">
        <fts-skeleton height="14px" width="56px" />
      </div>
    </div>
  </div>
</template>

<script>
import FTSSkeleton from "../FTSSkeletonScreen";

export default {
  components: {
    "fts-skeleton": FTSSkeleton,
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.skeleton-activity-stream {
  display: flex;
  align-items: flex-start;
  .skel-activity-stream-avatar {
    margin-right: .375rem;
  }
  .skel-activity-stream-info {
    flex: 1;
    .skel-activity-stream-row-alpha {
      margin-bottom: 0.25rem;
    }
    .skel-activity-stream-row-beta {
      display: flex;
      align-items: center;
      margin-bottom: .375rem;
      .skel-activity-stream-row-beta-l {
        flex: 1 1 60%;
      }
      .skel-audit {
        margin-left: .75rem;
      }
    }
  }
  .skel-audit {
    display: flex;
    align-items: center;
    .skel-audit-profile {
      margin-right: .275rem;
    }
  }
}
</style>